import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { configURI, configURI1  } from '../../../shared/apiUrlConfig';
import { InsuranceDoc } from '../../model/insurance.model'
import { APP_ID_RANDOM_PROVIDER } from '@angular/core/src/application_tokens';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import * as momenttimezone from 'moment-timezone';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { GetDocStatusByRole } from '../../../shared/globalService';


@Injectable()
export class InsuranceService {
  load;
  url = environment.configURI;  
  loginId;
  agentId;
  constructor(private getDocStatusByRole: GetDocStatusByRole,
    public httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
    this.agentId = localStorage.getItem("AgentId");
  }

  // get agent Docs
  insuranceDocGet(id) {
    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/vendor/' + id + '/insurances').catch(this.userFriendlyMsgs.errorHandler)
    } else {
      return this.httpClient.get(this.url + '/vendor/' + id + '/insurances').catch(this.userFriendlyMsgs.errorHandler)
    }
  }

  // get details of agent
  insdetails(docId) {
    return this.httpClient.get(this.url + '/vendors/insurances/document/' + this.agentId + '/' + docId).catch(this.userFriendlyMsgs.errorHandler)
  }

  doctypeget() {
    return this.httpClient.get(this.url + '/documents/GetDocumentTypesByCategory?Category=INSURANCE').catch(this.userFriendlyMsgs.errorHandler)
  }

  // create new agent info
  createNewAgentInsurance(data, insurancecarriers, type?) {
    var testTimeZone= ""; 

    if(data.expiration){
      var setTime = new Date(data.expiration);
    }
    else if(data.insuranceExpiration && data.autoexpiration && data.insuranceExpiration < data.autoexpiration){
     setTime = new Date(data.insuranceExpiration);  
    }else{
      setTime = new Date(data.autoexpiration);
    }
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }
    this.loginId = localStorage.getItem('loginID');
    const body = {
      DocumentStatus: data.documentStatus,
      vendor_id: data.MasterVendorId,
      policynum: data.policynum,
      phonenum: data.phonenum,
      contact: data.contact,
      insurancecarrier:insurancecarriers,
      insurancevendor: data.insurancevendor,
      address1: data.address1,
      address2: data.address2,
      city: data.city,
      state: data.state,
      postalcode: data.postalcode,
      expiration: testTimeZone,
      insuranceExpiration:data.insuranceExpiration,
      general_liability_occurance: data.generalliabilityoccurance,
      general_liability_aggregate: data.generalliabilityaggregate,
      wrongfull_liability_limit: data.wrongfullliabilitylimit,
      workmas_comp_liability_limit: data.workmascompliabilitylimit,
      onhookormotor_liability_limit: data.onhookormotorliabilitylimit,
      auto_liability_limit: data.autoliabilitylimit,
      auto_liability_expiration: data.autoexpiration,
      garage_liability_limit: data.garageliabilitylimit,
      cancellation_notice: data.cancellationnotice === true ? 'Y' : 'N',
      storage_location: data.storagelocation === true ? 'Y' : 'N',
      par_as_insured: data.parasinsured === true ? 'Y' : 'N',
      documenttype: data.documenttype || data.DocumentType,
      documentcode: data.documentcode,
      filename: data.fileName,
      documentlink: data.documentlink,
      created_by: this.loginId,
      exempt_check: data.exempt_check ? 1 : 0
    };
    return this.httpClient.post(this.url + '/vendors/insurance', body).catch(this.userFriendlyMsgs.errorHandler)
  }

  // update new agent info
  updateAgentInsurance(data, insurancecarriers, type?) {
    var testTimeZone= "";
    var insurancedate = momenttimezone(data.insuranceExpiration).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    var autoexpirationdate = momenttimezone(data.autoexpiration).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    if(data.documenttype != 'Certificate of Insurance'){
        if(data.expiration){
          var  setTime = new Date(data.expiration);
        }
    }    
    else if(insurancedate && autoexpirationdate && insurancedate < autoexpirationdate){
      var setTime = new Date(insurancedate);
    }else{
      setTime = new Date(autoexpirationdate);
    }
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }  
    
  //   var testTimeZone= "";
  //   if(data.expiration){
  //   const setTime = new Date(data.expiration);
  //   setTime.setHours(19);
  //   setTime.setMinutes(59);
  //   setTime.setSeconds(59);
  //   const estTimeZone = "America/New_York";
  //   const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
  //   var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
  //   /*** The following logic for Daylight Savings ***/
  //   if (testTimeZone.includes('-05:00')) {
  //     testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
  //   }
  // }
    this.loginId = localStorage.getItem('loginID');
    let body = {
      DocumentStatus: data.documentStatus,
      vendor_id: data.MasterVendorId,
      policynum: data.policynum,
      phonenum: data.phonenum,
      contact: data.contact,
      insurancecarrier:insurancecarriers,
      insurancevendor: data.insurancevendor,
      address1: data.address1,
      address2: data.address2,
      city: data.city,
      state: data.state,
      postalcode: data.postalcode,
      expiration: testTimeZone,
      insuranceExpiration:data.insuranceExpiration,
      general_liability_occurance: data.generalliabilityoccurance,
      general_liability_aggregate: data.generalliabilityaggregate,
      wrongfull_liability_limit: data.wrongfullliabilitylimit,
      workmas_comp_liability_limit: data.workmascompliabilitylimit,
      onhookormotor_liability_limit: data.onhookormotorliabilitylimit,
      auto_liability_limit: data.autoliabilitylimit,
      auto_liability_expiration: data.autoexpiration,
      garage_liability_limit: data.garageliabilitylimit,
      cancellation_notice: data.cancellationnotice === true ? 'Y' : 'N',
      storage_location: data.storagelocation === true ? 'Y' : 'N',
      par_as_insured: data.parasinsured === true ? 'Y' : 'N',
      documenttype: data.documenttype,
      documentcode: data.documentcode,
      filename: data.fileName,
      documentlink: data.documentlink,
      // delete: 0,
      updated_by: this.loginId,
      exempt_check: data.exempt_check ? 1 : 0,
      DocumentComments : data.documentComments,
      fileUpdated: data.fileUpdated
    };

    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.post(this.url + '/client/vendor/' + data.MasterVendorId + '/insurance/' + data.VendorInsuranceId, body).catch(this.userFriendlyMsgs.errorHandler)
    } else {
      return this.httpClient.post(this.url + '/vendors/insurances/document/'+ this.agentId + '/' + data.docid, body).catch(this.userFriendlyMsgs.errorHandler)
    }

  }

  deleteAgentInsurance(data) {
    const body = {
    };
    return this.httpClient.put(this.url + '/vendor/' + data.MasterVendorId + '/insurance/' + data.VendorInsuranceId, body).catch(this.userFriendlyMsgs.errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/insurance/insurance.service.ts